"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = exports.addAttribute = exports.init = void 0;
/**
 * 针对神策 sensor H5/Web端 sdk的进一步封装，减少业务接入难度
 *
 * 包含
 * 自动式监听SPA PV相关 全埋点 autoTrack
 * 自动式引入 神策sdk cdn选择
 * 以及部分优化系列
 * login 与 logout 等api则直接调用sdk本身
 */
var util_1 = require("./util");
var sensorSDK = require('./autotrack');
var commonAttributes = {};
var supportPushState = typeof window !== 'undefined' &&
    window.navigator &&
    (function () {
        var ua = window.navigator.userAgent;
        var blackList = ['Android 2.', 'Android 4.0'];
        if (blackList.some(function (v) { return ua.indexOf(v) > -1; }))
            return false;
        return window.history && typeof window.history.pushState === 'function';
    })();
// sensor sdk 初始化 和 自动注入相关
function init(config, params) {
    var _a;
    config = Object.assign({
        env: 'production',
        auto: true
    }, config);
    // 从window.location.search中获取showsensorlog参数，为1则显示日志
    var useSensorLog = sessionStorage.getItem('useSensorLog');
    var sensorParam = util_1.formatUrlParams('showsensorlog');
    // url中有showsensorlog=1, 缓存useSensorLog置1
    if (!+useSensorLog && +sensorParam === 1) {
        sessionStorage.setItem('useSensorLog', '1');
    }
    // 关闭:showsensorlog=0
    if (+useSensorLog && sensorParam && +sensorParam === 0) {
        sessionStorage.removeItem('useSensorLog');
    }
    config.show_log = +sessionStorage.getItem('useSensorLog') === 1;
    // 初始化全局sdk
    sensorSDK(config);
    // 是否开启SPA路由切换的自动pv等捕捉
    if (supportPushState && config.auto) {
        var sensorQuick = function () {
            return setTimeout(function () {
                var _a;
                /* eslint-disable-next-line */
                ;
                (_a = window.sensors) === null || _a === void 0 ? void 0 : _a.quick('autoTrackSinglePage');
            }, 0);
        };
        // push操作监听
        util_1.overrideNativeMethod('pushState', window.history.pushState, window.history, sensorQuick);
        // replace操作监听
        util_1.overrideNativeMethod('replaceState', window.history.replaceState, window.history, sensorQuick);
        // pop back操作监听
        util_1.overrideNativeMethod('onpopstate', window.onpopstate, window, sensorQuick);
        // 暂不添加haschange避免重复触发
    }
    // 注册公共属性
    /* eslint-disable-next-line */
    ;
    (_a = window.sensors) === null || _a === void 0 ? void 0 : _a.registerPage(__assign({ platform_type: config.platform_type, platform_name: config.platform_name, $app_id: config.appid || config.platform_name }, params));
    // 待上报数据处理,如果注册方法执行之前已经有待上报数据存在则上报
    if (window.hasOwnProperty('_cx_sensors_report_data') && Array.isArray(window._cx_sensors_report_data)) {
        var reportData = window._cx_sensors_report_data;
        for (var i = reportData.length - 1; i >= 0; i--) {
            var _b = reportData[i], _c = _b.eventId, eventId = _c === void 0 ? '' : _c, _d = _b.exAttrs, exAttrs = _d === void 0 ? {} : _d;
            this.track(eventId, exAttrs);
            // 删除已上报数据
            reportData.splice(i, 1);
        }
    }
}
exports.init = init;
// 添加统一内置的公共属性方法
function addAttribute(obj) {
    return Object.assign(commonAttributes, obj);
}
exports.addAttribute = addAttribute;
// sensor 数据上报
function track(eventId, exAttrs) {
    var _a;
    // 如果神策注册成功且已经在window上挂载sensors属性直接上报,否则存入缓存等待注册成功后再次上报
    if (window.hasOwnProperty('sensors')) {
        /* eslint-disable-next-line */
        return (_a = window.sensors) === null || _a === void 0 ? void 0 : _a.track(eventId, __assign(__assign({}, commonAttributes), exAttrs));
    }
    else {
        if (!window.hasOwnProperty('_cx_sensors_report_data')) {
            window._cx_sensors_report_data = [];
        }
        ;
        window._cx_sensors_report_data.push({ eventId: eventId, exAttrs: exAttrs });
    }
    return null;
}
exports.track = track;
exports.default = (function (UIP) {
    UIP.checkModule('sensor');
    Object.assign(UIP.sensor, {
        init: init,
        addAttribute: addAttribute,
        track: track
    });
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/sensor-sdk-h5/dist/index.js
// module id = YRR1
// module chunks = 1